/**
 * タブ切替モジュール
 */
export const TAB = {
  init() {
    const roots = document.querySelectorAll('.js-tab')
    roots.forEach(root => {
      if (root.__tabInstance) return
      root.__tabInstance = true
      this.setup(root)
    })
  },

  setup(root) {
    const switches = root.querySelectorAll('.c-tab__switch__item')
    const panels = root.querySelectorAll('.c-tab__content')
    if (!switches.length || !panels.length) return

    switches.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault()
        const target = btn.getAttribute('data-tab')
        if (!target) return

        switches.forEach(item => {
          const isActive = item.getAttribute('data-tab') === target
          item.classList.toggle('is-active', isActive)
          item.setAttribute('aria-selected', isActive ? 'true' : 'false')
        })

        panels.forEach(panel => {
          const isActive = panel.getAttribute('data-tab-content') === target
          panel.classList.toggle('is-active', isActive)
          panel.hidden = !isActive
        })
      })
    })
  },
}
